import { render, staticRenderFns } from "./SingleRow.vue?vue&type=template&id=a219707c&scoped=true&"
import script from "./SingleRow.vue?vue&type=script&lang=js&"
export * from "./SingleRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a219707c",
  null
  
)

export default component.exports